import { asyncCartridgeLoad } from '@/modules-es5/commons/lib/lib-lazyload';
import { addReviewsParamFromQuery, init as initProductReview } from '@/catalog/product-details/product-review';
//import { init as initReviewsFloor } from '@/catalog/product-details/reviews-floor';


export function init()  {
  // get the 'notes' query param and add it to the data-params of '#ReviewsFloor'
  addReviewsParamFromQuery('notes');

  if (cube.$id('product-reviews-list')) initProductReview();

  cube.event.off('async-content:ReviewsFloor', initProductReview);
  cube.event.on('async-content:ReviewsFloor', initProductReview);

  const productNotation = cube.$('.product-notation');
  // if user hovers the notation sumary (in conversion zone) we force the load of the async-ReviewsFloor
  if (productNotation) {
    const forceLazyLoad = () => {
      cube.lazyload.display(cube.$id('ReviewsFloor')); // load floor
      productNotation.off('mouseover', forceLazyLoad); // unbind 'mouseover' action
    };
    productNotation.on('mouseover', forceLazyLoad);
  }

  // Sort by note
  cube.$$('#details-review-content .notation-filter').on('click', e => {
    e.preventDefault();
    const note = e.currentTarget.dataset.notation;
    cube.$(`#ReviewsFloor [data-notation="${note}"]`).classList.add('active');
    cube.event.send('sort-reviews', e);
  });

  // SORT REVIEWS
  cube.event.off('sort-reviews', sortReviews);
  cube.event.on('sort-reviews', sortReviews);
}



function setCurrentModel(modelActivated) {
  cube.$$('#js-model-option .dkt-select__option').forEach(model => {
    if(model.dataset.value === modelActivated) {
      model.classList.add('dkt-select__option--selected');
      cube.$('#js-model-option .dkt-select__value').textContent = cube.$('#js-model-option .dkt-select__option--selected').textContent;
      cube.$id('dkt-select-model-option').value = cube.$('#js-model-option .dkt-select__option--selected').dataset.value;
    }
  });
}



// Set global options variable with default values
const cartridgeOptions = {
  offer    : '',
  notes    : '',
  sort     : '',
  direction: '',
  A        : '',
};


function populateOptions (floorReviews) {
  cartridgeOptions.offer = cube.$('#dkt-select-model-option') ? cube.$('#dkt-select-model-option').value : cartridgeOptions.offer;
  cartridgeOptions.notes = cube.$('#ReviewsFloor .notation-filter.active') ? cube.$('#ReviewsFloor .notation-filter.active').dataset.notation : cartridgeOptions.notes;

  if (cube.$('#dkt-select-sort-option') && cube.$('#dkt-select-sort-option').value && cube.$('#dkt-select-sort-option').value.split(';').length > 1 ) {
    cartridgeOptions.sort      = cube.$('#dkt-select-sort-option').value.split(';')[0];
    cartridgeOptions.direction = cube.$('#dkt-select-sort-option').value.split(';')[1];
  }

  if (cube.$('#product-reviews-list').dataset.productId){
    cartridgeOptions.A = `p-${cube.$('#product-reviews-list').dataset.productId}`;
  }
  else {
    const currentParams = floorReviews.dataset.params.split('&').reduce((acc, param) => {
      acc[param.split('=')[0]] = decodeURIComponent(param.split('=')[1]);
      return acc;
    }, {});

    cartridgeOptions.A = currentParams.A;
    cartridgeOptions.mc = currentParams.mc;
  }
}





function sortReviews() {
  const floorReviews = cube.$('#ReviewsFloor');

  if (!floorReviews) return;

  populateOptions(floorReviews);

  ///// If it's review page
  if(floorReviews.classList.contains('all-reviews')) {
    const p1 = new Promise(res => cube.cartridge('ReviewsFloor').after(res).reload(cartridgeOptions));
    const p2 = new Promise(res => cube.cartridge('ReviewsList').after(res).reload(cartridgeOptions));

    Promise.all([p1, p2]).then(() => {
      init();
      if (cartridgeOptions.offer !== '') setCurrentModel(cartridgeOptions.offer);
      // convert cartridgeOptions in GET Url params
      cube.$('#ReviewsFloor').dataset.params = Object.keys(cartridgeOptions).map(key => `${key}=${cartridgeOptions[key]}`).join('&');
    });
  }

  ///// If it's floor on product page
  else {
    // convert cartridgeOptions in GET Url params
    floorReviews.dataset.params = Object.keys(cartridgeOptions).map(key => `${key}=${cartridgeOptions[key]}`).join('&');

    asyncCartridgeLoad(floorReviews, () => {
      if (cartridgeOptions.offer !== '') setCurrentModel(cartridgeOptions.offer);
    });
  }
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/reviews-floor.js